

//button clss
export const buttonCls        = `border-primary border-1 status-btn bg-body text-body`;
export const buttonVariantCls = `body-secondary`;
export const buttonSpinnerCls = `spinner-border spinner-border-sm me-2`;

//input clss
export const inputCls      = `mb-3`;
export const inputLabelCls = `ms-1 mb-1`;
export const inputExplCls  = `d-block text-body-secondary ms-1`;
export const inputErrCls   = `d-block text-danger ms-1`;